<template>
	<div class="pa-3 activity-topic-edit" v-if="item && item.content">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-form ref="form" v-model="valid" lazy-validation :class="{ 'is-fade': loading }">
			<v-tabs v-model="active" color="grey lighten-5">
				<v-tab :key="1" ripple>General</v-tab>
				<v-tab :key="2" ripple>Prizes</v-tab>
				<v-tab :key="3" ripple>Candidates</v-tab>
				<v-tab :key="4" ripple>Winners</v-tab>
				<v-tab :key="5" ripple>Report</v-tab>

				<v-tab-item :key="1">
					<v-card flat class="mb-5">
						<v-card-text>
							<!--
							<v-switch v-model="item.content.published" label="Publish"></v-switch>
							<v-text-field v-model="item.content.slug" label="Slug" class="slug-input"></v-text-field>
							-->
							<v-text-field :value="item.content.title" label="Title" readonly required></v-text-field>

							<v-flex xs12 class="mb-4" >
								<v-img :max-width="480" :aspect-ratio="(600/315)" :src="item.content.coverUrl"></v-img>
							</v-flex>

		                    <v-flex xs12>
		                    	<h3 class="mb-2">Period</h3>
		                        <date-range-picker v-model="validityPeriod" period="Week" @input="handlePeriodChanged"></date-range-picker>
		                    </v-flex>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="2">
					<v-card flat class="mb-5 activity-prizes">
						<v-card-title primary-title>
							<h1 class="headline">Prizes</h1>
						</v-card-title>

						<v-card-text class="prize-list">
							<template v-for="type in prizeTypes">
								<h2>{{ type.title }}</h2>

								<ol class="prizes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.length">
									<li v-for="(prize, index) in item.prizes.filter(p => p.type == type.type).sort((a, b) => a.seqNo - b.seqNo)" :data-prefix="type.type.substring(0, 1)" :data-seq="prize.seqNo">
										<prize-edit 
											v-model="item.prizes[item.prizes.indexOf(prize)]"
											:disable-move-up="prize.seqNo == 1" 
											:disable-move-down="prize.seqNo == Math.max.apply(Math, item.prizes.filter(p => p.type == prize.type).map(function(o) { return o.seqNo; }))"
											@moveUp="handlePrizeMoveUp(prize)"
											@moveDown="handlePrizeMoveDown(prize)"
											@remove="handlePrizeRemove(prize)">
										</prize-edit>
									</li>
								</ol>

								<v-flex xs12>
									<v-btn color="secondary" @click="handlePrizeAdd(type.type)">Add</v-btn>
								</v-flex>

								<v-divider class="mt-3 mb-4"></v-divider>
							</template>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="3">
					<v-card flat class="mb-5 activity-candidates">
						<v-card-title primary-title>
							<h1 class="headline">Candidates</h1>
						</v-card-title>

						<v-card-text>
						    <v-layout pb-2>
						    	<v-flex class="text-xs-left">
									<v-btn-toggle v-model="source" mandatory>
										<v-btn flat value="comment">
											<v-icon class="mr-2">question_answer</v-icon>From Comments
										</v-btn>
										<v-btn flat value="csv" type="a" href="javascript:void(0);">
											<v-icon class="mr-2">upload_file</v-icon>Upload CSV
										</v-btn>
										<input type="file" ref="csvFileInput" accept=".csv" style="display: none;" @change="fileChange">
									</v-btn-toggle>
								</v-flex>
								<v-flex class="text-xs-right">
									<v-btn v-if="source == 'comment'" :color="'primary'" :disabled="loading" :loading="loading" @click="candidatesExport">
										<v-icon class="mr-2">get_app</v-icon>Export to CSV
									</v-btn>
								</v-flex>
						    </v-layout>

							<activity-comments-table v-if="item.sourceOfCandidates == 'comment'" :content-type="'TOPIC'" :content-id="item.topicId"></activity-comments-table>
							<activity-csv-table v-if="item.sourceOfCandidates == 'csv'" :file-id="item.importedCsvFileId"></activity-csv-table>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="4">
					<v-card flat class="mb-5 activity-winners">
						<v-card-title primary-title>
							<h1 class="headline">Winners</h1>
						</v-card-title>

						<v-card-text>
							<v-card>
								<v-card-text>
									<v-switch v-model="item.announced" label="ประกาศผลรางวัล"></v-switch>
									<date-time-picker v-if="item.announced" v-model="item.announcedAt"></date-time-picker>
								</v-card-text>
							</v-card>
						</v-card-text>

						<v-card-text class="prize-winner-list">

							<template v-for="type in prizeTypes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.filter(p => p.type == type.type).length">
								<h2>{{ type.title }}</h2>

								<ol class="prizes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.length">
									<li v-for="(prize, index) in item.prizes.filter(p => p.type == type.type).sort((a, b) => a.seqNo - b.seqNo)" :data-prefix="type.type.substring(0, 1)" :data-seq="prize.seqNo">
										<h3 class="title mb-2">{{ prize.title }}</h3>
										<p class="body-2" v-if="prize.description">{{ prize.description }}</p>

										<template v-if="prize.hasOwnProperty('winners') && Array.isArray(prize.winners)">

										<div class="mb-4" v-if="prize.winners.length">
											<v-chip class="text-xs-center subtitle mb-2" close v-for="winner in prize.winners" @input="handleWinnerRemove(winner)">
												<v-avatar>
													<img :src="winner.user.avatar" :alt="winner.user.username">
												</v-avatar>
												{{ winner.user.username }}
											</v-chip>
										</div>

										<v-btn :disabled="prize.winners.length >= prize.numberOfWinners" class="ma-0" color="secondary" @click="handleWinnersChoose(prize)">Choose Winners</v-btn>
										<winners-csv :prize-id="prize.id" :flat="true" :color="'secondary'" :file-title="prize.title">Export</winners-csv>

										</template>
									</li>
								</ol>

								<v-divider class="mt-3 mb-4"></v-divider>
							</template>

						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="5">
					<v-card flat class="mb-5 activity-winners">
						<v-card-title primary-title>
							<h1 class="headline">Report</h1>
						</v-card-title>

						<v-card-text class="prize-winner-list">

							<template v-for="type in prizeTypes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.filter(p => p.type == type.type).length">
								<h2>{{ type.title }}</h2>

								<ol class="prizes" v-if="prizeReports && item && item.prizes && Array.isArray(item.prizes) && item.prizes.length">
									<li class="pb-5" v-for="(prize, index) in item.prizes.filter(p => p.type == type.type).sort((a, b) => a.seqNo - b.seqNo)" :data-prefix="type.type.substring(0, 1)" :data-seq="prize.seqNo">
										<h3 class="title mb-2">{{ prize.title }}</h3>
										<p class="body-2" v-if="prize.description">{{ prize.description }}</p>

										<prize-performance v-for="data in prizeReports.filter(z => z.id == prize.id)" :data="data"></prize-performance>
									</li>
								</ol>
							</template>

						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>

			<v-footer fixed flat height="auto" color="grey lighten-2 px-3">
				<v-layout row wrap>
					<v-btn color="primary" @click="handleSave" :disabled="!valid">Save</v-btn>
					<v-btn flat @click="handleCancel">Cancel</v-btn>
				</v-layout>
			</v-footer>
		</v-form>

		<winners-choose 
			:prize="prizeToBeChoosed" 
			:candidates="candidates" 
			:ignored-user-ids="selectedCandidateIds"
			@close="prizeToBeChoosed = null" 
			@selected="handleWinnersSelected">
		</winners-choose>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import DateRangePicker from '@/components/DateRangePicker.vue'
	import DateTimePicker from '@/components/DateTimePicker.vue'
	import ImageUpload from '@/components/ImageUpload.vue'
	import RelatedProducts from '@/components/RelatedProducts.vue'

	import PrizeEdit from '@/components/PrizeEdit.vue'
	import ActivityCommentsTable from '@/views/activity/CommentsTable.vue'
	import ActivityCsvTable from '@/views/activity/CsvTable.vue'

	import WinnersChoose from '@/components/WinnersChoose.vue'
	import WinnersCsv from '@/components/WinnersCsv.vue'

	import PrizePerformance from '@/components/PrizePerformance.vue'

	export default {
		components: {
			'date-range-picker': DateRangePicker,
			'date-time-picker': DateTimePicker,
			'image-upload': ImageUpload,
			'related-products': RelatedProducts,
			'prize-edit': PrizeEdit,
			'activity-comments-table': ActivityCommentsTable,
			'activity-csv-table': ActivityCsvTable,
			'winners-choose': WinnersChoose,
			'winners-csv': WinnersCsv,
			'prize-performance': PrizePerformance
		},
		data () {
			let prizeType = {
				RANKING: 'RANKING',
				LUCKY: 'LUCKY',
				SPECIFIC: 'SPECIFIC'
			}

			return {
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: config.PUBLIC_PATH
					},
					{
						text: 'Activity',
						disabled: true,
						href: `${config.PUBLIC_PATH}activity`
					},
					{
						text: 'Activity Topics',
						disabled: false,
						href: `${config.PUBLIC_PATH}activity/activity-topic`
					}
				],
				rules: {
					text: [
						v => !!v || 'Field is required'
					],					
					number: [
						v => !!v || 'Field is required',
						v => (parseInt(v) > 0) || 'Value must be greater than 0'
					],					
				},
				prizeType: prizeType,
				prizeTypes: [
					{
						type: prizeType.RANKING,
						title: 'Rankings'
					},
					{
						type: prizeType.LUCKY,
						title: 'Lucky Draw'
					},
					{
						type: prizeType.SPECIFIC,
						title: 'Specific / Munually Pickup'
					}
				],

				valid: true,
				active: null,
				loading: false,

				item: null,
				source: null,
				validityPeriod: {
					startDate: null,
					endDate: null
				},

				ts: new Date().getTime(),

				emptyCriteria: {
					selects: [],
					genders: [],
					ages: [0, 0],
					skinTones: [],
					skinConditions: [],
					hairColors: [],
					hairConditions: [],
					skinProblems: [],
					skinProblemsAll: 0,
					bodyProblems: [],
					bodyProblemsAll: 0,
					hairProblems: [],
					hairProblemsAll: 0,
        		},

        		prizeToBeChoosed: null,
        		candidates: [],
        		prizeReports: []
			}
		},
		computed: {
			validity () 
			{
				return (this.validityPeriod.startDate && this.validityPeriod.endDate) ? `${this.validityPeriod.startDate} to ${this.validityPeriod.endDate}` : ''
			},
			selectedCandidateIds () {
				return this.item.prizes.reduce((accumulator, value) => (value.hasOwnProperty('winners')) ? accumulator.concat(value.winners.map(w => w.userId)) : [], [])
			}
		},
		methods: {
	        handlePeriodChanged () 
	        {
				this.activityContent.startDate = this.validityPeriod.startDate
				this.activityContent.endDate = this.validityPeriod.endDate
	        },
	        handlePrizeAdd (t) 
	        {
	        	let maxSeq = 0
	        	if (this.item.prizes.filter(p => p.type == t).length) {
		        	maxSeq = Math.max.apply(Math, this.item.prizes.filter(p => p.type == t).map(function(o) { return o.seqNo; }))
	        	}

	        	this.item.prizes.push({
	        		id: null,
	        		contentType: 'TOPIC',
	        		contentId: this.item.content.id,
	        		type: t,
	        		title: '',
	        		imageUrl: null,
	        		numberOfWinners: 1,
	        		seqNo: (maxSeq + 1),
	        		products: [],
	        		winners: [],
	        		criteria: JSON.parse(JSON.stringify(this.emptyCriteria)),
	        	})
	        },
	        handlePrizeMoveUp (prize)
	        {
	        	let siblingIndex = JSON.parse(JSON.stringify(this.item.prizes.indexOf(this.item.prizes.filter(p => p.type == prize.type && p.seqNo < prize.seqNo).sort((a, b) => b.seqNo - a.seqNo)[0])))

	        	this.item.prizes[siblingIndex].seqNo++
	        	prize.seqNo--

	        	this.ts = new Date().getTime()
	        },
	        handlePrizeMoveDown (prize)
	        {
	        	let siblingIndex = JSON.parse(JSON.stringify(this.item.prizes.indexOf(this.item.prizes.filter(p => p.type == prize.type && p.seqNo > prize.seqNo).sort((a, b) => a.seqNo - b.seqNo)[0])))

	        	this.item.prizes[siblingIndex].seqNo--
	        	prize.seqNo++

	        	this.ts = new Date().getTime()
	        },
	        handlePrizeRemove (prize) 
	        {
				this.$swal({
					title: 'Are you sure?',
					text: "Delete Prize ?",
					icon: 'warning',
					showCancelButton: true
				}).then(response => {
					if (response.value) {
			        	let prizeType = prize.type

			        	this.item.prizes.splice(this.item.prizes.indexOf(prize), 1)
			        	this.$nextTick(() => {
				        	this.prizesResequence(prizeType)
			        	})
					}
				})
	        },
	        prizesResequence (prizeType)
	        {
	        	let seqNo = 1;
	        	this.item.prizes.filter(p => p.type == prizeType).sort((a, b) => a.seqNo - b.seqNo).forEach(prize => {
	        		let prizeIndex = this.item.prizes.indexOf(prize)
	        		this.item.prizes[prizeIndex].seqNo = seqNo
	        		seqNo++
	        	})
	        },

			handleCancel ()
			{
				this.$router.push({'path': `${config.PUBLIC_PATH}activity/activity-topic`})
			},
			handleSave () {
	    		if ((!this.item.topicId)) {
	    			this.$store.commit(types.SET_ERROR_MSG, "No content picked.")
	    			return false
	    		}
	    		if ((!this.validityPeriod.startDate) || (!this.validityPeriod.endDate)) {
	    			this.$store.commit(types.SET_ERROR_MSG, "Please select validity period.")
	    			return false
	    		}

	    		this.item.startDate = this.validityPeriod.startDate
	    		this.item.endDate = this.validityPeriod.endDate

	    		if (!this.item.announced) {
	    			this.item.announcedAt = null
	    		} else if (this.item.announcedAt == null) {
					let now = new Date()
					let todayUTC = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes()))

					this.item.announcedAt = `${todayUTC.toISOString().slice(0, 10)} ${todayUTC.toISOString().slice(11, 16)}`
	    		}

		    	axios.put(`${config.BASE_URL}/activityTopic/${this.$route.params.topicId}`, this.item)
		    		.then((response) => {
		    			if (response.data.code == 0) {
		    				this.$store.commit(types.SET_SUCCESS_MSG, "Update completed")
		    				this.reloadCandidates()
		    			} else {
		    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
		    			}
		    		}).catch(function (error) {

					})
			},
			setItem (item) {
				if (item.hasOwnProperty('prizes') && Array.isArray(item.prizes) && item.prizes.length) {
					item.prizes.forEach((prize, index) => {
						if (!prize.hasOwnProperty('criteria') || !prize.criteria) {
							item.prizes[index].criteria = JSON.parse(JSON.stringify(this.emptyCriteria))
						} else {
							item.prizes[index].criteria.selects = []
							if (item.prizes[index].criteria.genders.length) item.prizes[index].criteria.selects.push('gender')
							if ((item.prizes[index].criteria.ages[0] > 0) && (item.prizes[index].criteria.ages[1] > 0)) item.prizes[index].criteria.selects.push('age')
							if (item.prizes[index].criteria.skinTones.length) item.prizes[index].criteria.selects.push('skinTone')
							if (item.prizes[index].criteria.skinConditions.length) item.prizes[index].criteria.selects.push('skinCondition')
							if (item.prizes[index].criteria.hairColors.length) item.prizes[index].criteria.selects.push('hairColor')
							if (item.prizes[index].criteria.hairConditions.length) item.prizes[index].criteria.selects.push('hairCondition')
							if (item.prizes[index].criteria.skinProblems.length) item.prizes[index].criteria.selects.push('skinProblem')
							if (item.prizes[index].criteria.bodyProblems.length) item.prizes[index].criteria.selects.push('bodyProblem')
							if (item.prizes[index].criteria.hairProblems.length) item.prizes[index].criteria.selects.push('hairProblem')
						}
					})
				}

				if (!item.hasOwnProperty('sourceOfCandidates')) {
					item.sourceOfCandidates = 'comment'
				}

				this.item = item
				this.source = item.sourceOfCandidates

				this.item.topicId = item.content.id
				// this.item.slug = item.content.slug
				// this.item.published = item.content.published

				this.validityPeriod = {
					startDate: this.item.startDate,
					endDate: this.item.endDate
				}

    			if (this.item.content.coverUrl.substring(0, 4) != 'http') {
    				this.item.content.coverUrl = `https://${(`www.jeban.com/${this.item.content.coverUrl}`).replace('//', '/')}`
    			}

				this.breadcrumbs.push({
					text: this.item.content.title,
					disabled: true,
					href: ''
				})
			},
			fileChange (event) {
				if (event.target.files.length) {
					var formData = new FormData()

					formData.append("csv", event.target.files[0])

					this.loading = true

					axios.post(`${config.BASE_URL}/csv`, formData, {
					    headers: {
					      'Content-Type': 'multipart/form-data'
					    }
					}).then(response => {
						this.loading = false

						if (response.data.code == 0) {
							this.item.importedCsvFileId = response.data.data.id
							this.$nextTick(() => {
								this.item.sourceOfCandidates = this.source
							})
						} else {
							this.$swal({
								title: 'Error!',
								text: response.data.message,
								type: 'error'
							})							
						}
					})

					this.$refs.csvFileInput.value = ""
				} else {
					this.source = this.item.sourceOfCandidates
				}
			},
			handleWinnersChoose (prize) {
				this.prizeToBeChoosed = prize
			},
			handleWinnersSelected (candidates) {
	        	let maxSeq = 0
	        	if (this.prizeToBeChoosed.winners.length) {
		        	maxSeq = Math.max.apply(Math, this.prizeToBeChoosed.winners.map(function(o) { return o.seqNo }))
	        	}

	        	candidates.forEach(c => {
	        		maxSeq++

					this.prizeToBeChoosed.winners.push({
						userId: c.userId,
						title: c.username,
						user: {
							id: c.userId,
							username: c.username,
							avatar: c.avatar
						},
						seqNo: maxSeq
					})
	        	})

	        	this.prizeToBeChoosed = null
			},
			handleWinnerRemove (winner) {
				this.$swal({
					title: 'Are you sure?',
					text: `Remove ${winner.title}`,
					icon: 'warning',
					showCancelButton: true
				}).then(response => {
					if (response.value) {
						this.item.prizes.forEach((p, pIdx) => {
							if (p.winners.indexOf(winner) >= 0) {
								this.item.prizes[pIdx].winners.splice(p.winners.indexOf(winner), 1)
							}
						})
					}
				})	        		
			},
			reloadCandidates () {
				axios.get(`${config.BASE_URL}/activityTopic/${this.$route.params.topicId}/candidatesWithProfile`)
					.then(response => {
						this.candidates = response.data.data
					})
			},
			candidatesExport () {
				this.loading = true
				
				let url = `${config.BASE_URL}/comments/topic/${this.$route.params.topicId}/csv`

				axios.get(url)
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]))
						const link = document.createElement('a')
						
						link.href = url
						link.setAttribute('download', `topic-${this.$route.params.topicId}-comments.csv`)
						document.body.appendChild(link)
						link.click()

	  					this.loading = false
					})
					.catch((error) => {
						this.loading = false
						this.$store.commit(types.SET_ERROR_MSG, error)
					})
			},
			reloadReport () {
				axios.get(`${config.BASE_URL}/luckylist/prize/performanceReport?prize=${this.item.prizes.map(p => p.id).join(',')}`)
					.then(response => {
						this.prizeReports = response.data.data
					})
			}
		},
		async mounted () {
			history.pushState(null, null, location.href)

		    window.onpopstate = function () {
		        history.go(1)
		    }

		    this.loading = true

		    if (this.$route.params.topicId !== undefined) {
		    	this.loading = true

		    	await axios.get(`${config.BASE_URL}/activityTopic/${this.$route.params.topicId}`)
		    		.then((response) => {
		    			if (response.data.data) {
			    			this.setItem(response.data.data)

			    			this.loading = false
		    			} else {
		    				axios.get(`${config.BASE_URL}/topic/${this.$route.params.topicId}`)
		    					.then(response => {
		    						let toDay = new Date()
		    						let nextMonth = new Date(new Date((new Date).setMonth((new Date).getMonth() + 1)).setDate((new Date).getDate() - 1))

		    						this.setItem({
		    							content: response.data.data,
		    							startDate: `${toDay.getFullYear()}-${('0' + (toDay.getMonth()+1)).slice(-2)}-${('0' + toDay.getDate()).slice(-2)}`,
		    							endDate: `${nextMonth.getFullYear()}-${('0' + (nextMonth.getMonth()+1)).slice(-2)}-${('0' + nextMonth.getDate()).slice(-2)}`,
		    							prizes: [],
		    							sourceOfCandidates: 'comment',
		    							importedCsvFileId: null
		    						})

									this.loading = false
		    					})
		    			}
		    		})
		    }
		},
		watch: {
			'item.sourceOfCandidates' (newValue) {
				if (newValue) {
					this.reloadCandidates()
				}
			},
	        source (newValue) {
	        	if (newValue == this.item.sourceOfCandidates) return

	        	if (newValue == 'csv') {
					this.$swal({
						title: 'Are you sure?',
						text: "Existing candidates will be replaced!!",
						icon: 'warning',
						showCancelButton: true
					}).then(response => {
						if (response.value) {
			        		// this.item.sourceOfCandidates = newValue
			        		this.$refs.csvFileInput.click()
						} else {
							this.source = this.item.sourceOfCandidates
						}
					})	        		
	        	} else {
	        		this.item.sourceOfCandidates = newValue
	        		this.item.importedCsvFileId  = null
	        	}
	        },
	        active (newValue) {
	        	if (newValue == 4) {
	        		this.reloadReport()
	        	}
	        }
		}
	}
</script>

<style lang="scss">
	.activity-topic-edit {
		h1, h2 {
			font-weight: normal;
		}
		h2 {
			margin-bottom: 1rem;
		}

		.activity-prizes, 
		.activity-winners {
			.v-card__text.prize-list {
				padding-left: 3rem;
			}

			.number-input {
				width: 160px;
			}

			ol.prizes {
				counter-reset: item;
				list-style-type: none;

				padding-left: 48px;

				> li {
					position: relative;

					&:before {
						// content: attr(data-prefix) counter(item, decimal);
						content: attr(data-prefix) attr(data-seq);
						counter-increment: item;
						position: absolute;
						width: 2.5rem;
						left: -3.5rem;
						top: 1.125rem;
						height: 2.5rem;
						border-radius: 50%;
						background: #eaeaea;
						display: grid;
						align-items: center;
						justify-content: center;
					}

					&:not(:last-of-type) {
						margin-bottom: 2rem;
					}
				}
			}
		}
	}
</style>